import 'zdocs-web-core/theme/modern-reset.css';
import 'zdocs-web-core/theme/zdocs-reset.css';

import React from 'react';
import { createRoot } from 'react-dom/client';

import ErrorBoundary from 'zdocs-web-core/lib/error/ErrorBoundary';
import { rumInit } from 'zdocs-web-core/lib/rum';
import { Service } from 'zdocs-web-core/lib/constants';
import { getTokenFromUrl } from 'zdocs-web-core/lib/doc-editor';
import { getBrandOptions, brandInit } from '~/core/components/BrandProvider';
import App from './App';

function getTokenInfo() {
  try {
    return getTokenFromUrl();
  } catch {}
}

export default function init() {
  const container = document.getElementById('root');

  if (!container) {
    throw new Error('Root element not found');
  }

  const tokenInfo = getTokenInfo();
  const brand = getBrandOptions();

  rumInit(Service.StandaloneEditor, tokenInfo);
  brandInit(brand);

  const root = createRoot(container);
  root.render(
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  );
}
